import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { formatISO } from "@/utils/date";

import { OrderDetailsComponent } from "./orderDetails.component";

type OrderDetailsProps = {
    orderDetails: OrderDetailsModel;
};

const OrderDetails = ({ orderDetails }: OrderDetailsProps) => {
    const creationDate = formatISO(orderDetails.creationDate);

    return (
        <OrderDetailsComponent
            creationDate={creationDate}
            payments={orderDetails.payments}
        />
    );
};

export { OrderDetails };
